import { render, staticRenderFns } from "./addLearnSpan.vue?vue&type=template&id=03f087ad&scoped=true&"
import script from "./addLearnSpan.vue?vue&type=script&lang=js&"
export * from "./addLearnSpan.vue?vue&type=script&lang=js&"
import style0 from "./addLearnSpan.vue?vue&type=style&index=0&id=03f087ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f087ad",
  null
  
)

export default component.exports